import React from "react";
import logo from "./onelogin-logo.svg";
import styles from "./FatalError.module.css";

export const FatalError = ({ message }) => {
  return (
    <div className={styles.Container}>
      <img src={logo} alt="" />
      <div className={styles.Header}>
        An unexpected error seems to have occurred.
      </div>
      <div className={styles.Message}>{message}</div>
      <div className={styles.Help}>
        We're investigating the problem and expect to be back soon. Please wait
        a few minutes
        <br />
        and refresh your browser, or visit our{" "}
        <a href="https://www.onelogin.com/status">Status Page</a>.
      </div>
    </div>
  );
};
